<div class="row" class="table-row">
  <table mat-table [dataSource]="products" class="mat-elevation-z8">
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let product" class="product-name-cell">
        <span>{{ product.name }}</span>
        @if (shouldShowCopiedIcons && product.isCopiedFromSupplier) {
          <ng-container>
            <mat-icon
              class="copied-icon"
              [attr.aria-label]="
                translationService.getMarketplaceCopiedFromSupplierText()
              "
              [title]="
                translationService.getMarketplaceCopiedFromSupplierText()
              "
              [matTooltip]="
                translationService.getMarketplaceCopiedFromSupplierText()
              "
              matTooltipPosition="above"
              >content_copy</mat-icon
            >
          </ng-container>
        }
      </td>
    </ng-container>
    <ng-container matColumnDef="brand">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let product" class="brand-cell">
        {{ product.brand }}
      </td>
    </ng-container>
    <ng-container matColumnDef="marketplaceCategory">
      <th mat-header-cell *matHeaderCellDef>
        {{ translationService.getMarketplaceCategoryLabelText() }}
      </th>
      <td mat-cell *matCellDef="let product">
        {{
          translationService.getMarketplaceCategoryText(
            product.marketplaceCategory
          )
        }}
      </td>
    </ng-container>
    <ng-container matColumnDef="viewAction">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let product">
        <span class="product-actions">
          <a
            [routerLink]="['/products/' + product.id + '/overview']"
            class="dark-link-underline"
            >{{ translationService.getViewText() }}
          </a>
          @if (showCloneButton && !product.isCopiedFromSupplier) {
            <a
              [routerLink]="['/product-add']"
              [queryParams]="{ originalProductId: product.id, cloning: true }"
              class="dark-link-underline"
              >{{ translationService.getCloneText() }}
            </a>
            <a
              [routerLink]="['/product-add']"
              [queryParams]="{ originalProductId: product.id, editing: true }"
              class="dark-link-underline"
              >{{ translationService.getEditText() }}
            </a>
          }
          @if (shouldShowShareProducts) {
            <a
              class="dark-link-underline"
              role="button"
              tabindex="0"
              (click)="onShareClick(product)"
              (keydown.enter)="onShareClick(product)"
              (keydown.space)="onShareClick(product)"
            >
              {{ translationService.getShareText() }}
            </a>
          }
        </span>
      </td>
    </ng-container>
    <ng-container matColumnDef="addToCatalogueAction">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let product">
        @if (shouldShowAddToCatalogue()) {
          <span class="product-actions">
            <a
              tabindex="0"
              (click)="addToCatalogue.emit(product)"
              (keydown.enter)="addToCatalogue.emit(product)"
              class="dark-link-underline"
            >
              {{ translationService.getAddToCatalogueText() }}
            </a>
          </span>
        }
      </td>
    </ng-container>

    <ng-container matColumnDef="toggleDiscontinuedSlider">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let product">
        @if (shouldShowDiscontinued) {
          <div class="discontinued-toggle-wrapper">
            <mat-slide-toggle
              [checked]="!product.discontinued"
              (change)="
                toggleDiscontinue.emit({
                  productId: product.id,
                  discontinued: !$event.checked,
                })
              "
            >
              {{
                product.discontinued
                  ? translationService.getDiscontinuedText()
                  : translationService.getActiveText()
              }}
            </mat-slide-toggle>

            @if (product.discontinued && product.discontinuedYear) {
              <span class="discontinued-year-caption">
                {{
                  translationService.getDiscontinuedEffectiveYearText(
                    product.discontinuedYear
                  )
                }}
              </span>
            }
          </div>
        }
      </td>
    </ng-container>

    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>
